import { useTheme } from '@mui/material';
import { UserIconProps } from './iconProps.interface';

export const ArrowRightIcon = ({ width, height, className }: UserIconProps) => {
    const theme = useTheme();
    const primaryIconStrokeColor = theme.colors.other.icon.stroke.primary;

    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.3431 5.29289L22.7071 11.6569C23.0976 12.0474 23.0976 12.6805 22.7071 13.0711L16.3431 19.435C15.9526 19.8256 15.3195 19.8256 14.9289 19.435C14.5384 19.0445 14.5384 18.4113 14.9289 18.0208L19.5858 13.364H2C1.44772 13.364 1 12.9162 1 12.364C1 11.8117 1.44772 11.364 2 11.364H19.5858L14.9289 6.70711C14.5384 6.31658 14.5384 5.68342 14.9289 5.29289C15.3195 4.90237 15.9526 4.90237 16.3431 5.29289Z"
                fill={primaryIconStrokeColor}
            />
        </svg>
    );
};
